import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Users, ShieldOff, ShieldCheck } from "lucide-react";

export function InternalTeamList() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/settings/telegram/internal").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (r) => {
    setBusy(String(r.chat_id));
    try {
      await api.post(`/settings/telegram/internal/${r.chat_id}/${r.revoked ? "restore" : "revoke"}`);
      toast.success(r.revoked ? `Akses ${r.name} dipulihkan` : `Akses ${r.name} dicabut`);
      load();
    } catch { toast.error("Gagal memperbarui akses"); }
    setBusy("");
  };

  return (
    <div className="mt-4 p-3 border border-border rounded-sm" data-testid="tg-internal-team">
      <div className="flex items-center gap-2 font-medium text-sm"><Users className="w-4 h-4 text-muted-foreground" /> Tim Internal (kode HNB)</div>
      <div className="text-xs text-muted-foreground mb-3">Anggota yang dikenali bot. Penawaran mereka diteruskan ke Direktur sebelum dikirim ke customer.</div>
      {rows.length === 0 ? (
        <div className="text-xs text-muted-foreground py-2" data-testid="tg-internal-empty">Belum ada anggota tim yang terdaftar.</div>
      ) : (
        <div className="divide-y divide-border">
          {rows.map((r) => (
            <div key={r.chat_id} className="flex items-center justify-between gap-3 py-2" data-testid={`tg-internal-row-${r.chat_id}`}>
              <div className="min-w-0">
                <div className="text-sm font-medium truncate">{r.name || "-"} {r.username && <span className="text-xs text-muted-foreground">@{r.username}</span>}
                  <span data-testid={`tg-internal-role-${r.chat_id}`}
                    className={`ml-2 text-[10px] font-bold px-1.5 py-0.5 rounded-sm ${(r.role || "director") === "director" ? "bg-primary text-primary-foreground" : "bg-amber-100 text-amber-800"}`}>
                    {(r.role || "director") === "director" ? "Direktur" : "Marketing"} · {r.code || "HNB"}
                  </span></div>
                <div className="text-[11px] text-muted-foreground">
                  {r.revoked ? <span className="text-destructive font-medium">Akses dicabut</span> : <span className="text-emerald-700 font-medium">Aktif</span>}
                  {" · "}terakhir {(r.last_seen || "").slice(0, 16).replace("T", " ")}
                </div>
              </div>
              <Button size="sm" variant="outline" className="rounded-sm shrink-0" disabled={busy === String(r.chat_id)} onClick={() => toggle(r)}
                data-testid={`tg-internal-${r.revoked ? "restore" : "revoke"}-${r.chat_id}`}>
                {r.revoked ? <><ShieldCheck className="w-4 h-4 mr-1" /> Pulihkan</> : <><ShieldOff className="w-4 h-4 mr-1" /> Cabut Akses</>}
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
